import React, { useState } from "react";
import {
  startPayFastCheckout,
  SUBSCRIPTIONS_ENABLED,
} from "../../lib/payments/subscriptions";

export default function SubscriptionPopup({
  open,
  onClose,
  title,
  message,
  helperText,
  primaryLabel,
  onCheckAgain,
}) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  if (!open) return null;

  const effectiveTitle = SUBSCRIPTIONS_ENABLED
    ? title || "Continue your Gwin journey"
    : title || "Journey access unavailable";

  const effectiveMessage = SUBSCRIPTIONS_ENABLED
    ? message ||
      "Subscribe to Gwin monthly to keep progressing through your business finance journey."
    : message ||
      "This part of your Gwin journey is not currently available on your account.";

  const effectiveHelperText = SUBSCRIPTIONS_ENABLED
    ? helperText ||
      "Your monthly subscription gives you continued journey access, with up to 3 new levels available each week."
    : helperText || "";

  const effectivePrimaryLabel = SUBSCRIPTIONS_ENABLED
    ? primaryLabel || "Subscribe Monthly"
    : primaryLabel || "Okay";

  const handlePrimaryClick = async () => {
    if (!SUBSCRIPTIONS_ENABLED) {
      if (typeof onCheckAgain === "function") {
        onCheckAgain();
        return;
      }

      onClose?.();
      return;
    }

    try {
      setError("");
      setLoading(true);
      await startPayFastCheckout();
    } catch (err) {
      console.error("PayFast subscription checkout failed:", err);
      setError(
        err?.message ||
          "We could not start the subscription checkout. Please try again."
      );
      setLoading(false);
    }
  };

  return (
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/60 px-4"
      role="dialog"
      aria-modal="true"
      aria-labelledby="subscription-popup-title"
    >
      <div className="w-full max-w-[360px] rounded-[24px] bg-white p-6 text-center shadow-2xl">
        <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-[#FFF4EC] text-3xl">
          🔒
        </div>

        <h2
          id="subscription-popup-title"
          className="text-[22px] font-bold leading-tight text-[#333333]"
        >
          {effectiveTitle}
        </h2>

        <p className="mt-3 text-[14px] leading-relaxed text-[#666666]">
          {effectiveMessage}
        </p>

        {effectiveHelperText && (
          <p className="mt-3 text-[13px] leading-relaxed text-[#757575]">
            {effectiveHelperText}
          </p>
        )}

        {error && (
          <p className="mt-4 rounded-xl bg-red-50 px-3 py-2 text-[13px] font-semibold text-red-600">
            {error}
          </p>
        )}

        <button
          type="button"
          onClick={handlePrimaryClick}
          disabled={loading}
          className="mt-6 flex h-12 w-full items-center justify-center rounded-xl bg-[#FF914D] text-[15px] font-bold text-white transition hover:bg-[#cc4e00] disabled:cursor-not-allowed disabled:opacity-70"
        >
          {loading ? "Opening PayFast..." : effectivePrimaryLabel}
        </button>

        <button
          type="button"
          onClick={onClose}
          disabled={loading}
          className="mt-3 flex h-11 w-full items-center justify-center rounded-xl border border-[#E0E0E0] bg-white text-[14px] font-bold text-[#555555] transition hover:bg-[#F7F7F7] disabled:cursor-not-allowed disabled:opacity-70"
        >
          Not now
        </button>

        {SUBSCRIPTIONS_ENABLED && (
          <p className="mt-4 text-center text-xs leading-relaxed text-[#8A8A8A]">
            Subscription access is billed monthly. Your learning pace remains
            limited to 3 new levels per week.
          </p>
        )}
      </div>
    </div>
  );
}
